import { useRef } from 'react';
import { usePrefersReducedMotion } from './use-prefers-reduced-motion';

/**
 * False until `key`, a cheap identity of the rendered data, differs from the
 * one seen at mount; true from that same render on, so a chart animates in the
 * commit that carries the new data and never on its first paint.
 */
export const useAnimateAfterDataChange = (key: string): boolean => {
    const prefersReducedMotion = usePrefersReducedMotion();
    const mountKey = useRef(key);
    const changed = useRef(false);

    if (key !== mountKey.current) {
        changed.current = true;
    }

    return changed.current && !prefersReducedMotion;
};
